import React from 'react'
import Tabs from '../components/tabs'

const Prices = () => {

    const tabs = [
        {
            id: 'Classes',
            label: 'Classes',
            content: [
                { id: 1, column1Title: 'Number Of Hours', column2Title: 'Amount Per Student' },
                { id:2, column1: '4 hours / week', column2: '250$ / Month'},
                { id: 2, column1: '6 hours / week', column2: '375$ / Month' },
                { id: 2, column1: '8 hours / week', column2: '500$ / Month' },
                // Add more rows as needed $
            ],
        },
        {
            id: 'Private',
            label: 'Private Sessions',
            content: [
                { id: 1, column1Title: 'Grade', column2Title: 'Hourly Rate' },
                { id:2, column1: '7', column2: '35 $'},
                { id: 2, column1: '8', column2: '35 $' },
                { id: 2, column1: '9', column2: '40 $' },
                { id: 2, column1: '10', column2: '40 $' },
                { id: 2, column1: '11 - L', column2: '40 $' },
                { id: 2, column1: '11 - S', column2: '45 $' },
                { id: 2, column1: '12 - SE(ES)', column2: '45 $' },
                { id: 2, column1: '12 - SV(LS)', column2: '50 $' },
                { id: 2, column1: '12 - SG(GS)', column2: '50 $' },
                // Add more rows as needed $
            ],
        }
        // {
        //     id: 'Group',
        //     label: 'Group Sessions',
        //     content: [
        //         { id: 1, column1Title: 'Grade', column2Title: 'Hourly Rate/Student' },
        //         { id: 2, column1: '7', column2: '25 $'},
        //         { id: 2, column1: '8', column2: '25 $' },
        //         { id: 2, column1: '9', column2: '30 $' },
        //         { id: 2, column1: '10', column2: '30 $' },
        //         { id: 2, column1: '11 - L', column2: '30 $' },
        //         { id: 2, column1: '11 - S', column2: '35 $' },
        //         { id: 2, column1: '12 - SE(ES)', column2: '35 $' },
        //         { id: 2, column1: '12 - SV(LS)', column2: '40 $' },
        //         { id: 2, column1: '12 - SG(GS)', column2: '40 $' },
        //         // Add more rows as needed $
        //     ],
        // },
        // Add more tabs as needed
    ];

    return (
        <div className='w-full h-auto lg:py-10 py-3' id='payment'>
            <div className='flex flex-col text-center lg:gap-16 gap-8'>
                <h1 className='font-semibold text-4xl'>Payment</h1>
                <div className='justify-center flex'>
                    <Tabs tabs={tabs} />
                </div>
            </div>
        </div>
    )
}

export default Prices